import { gql, useMutation } from "@apollo/client"

const DESTROY_DOCUMENT_QUERY = gql`
  mutation OffboardingDestroyDocument($documentId: String!) {
    destroyDocument(input: { documentId: $documentId }) {
      errors
    }
  }
`

export const useDestroyDocumentMutation = () => useMutation(DESTROY_DOCUMENT_QUERY)
